import { ReactNode } from "react";

interface Props {
	children: ReactNode;
	className?: string;
}
export default function Paragraph({ children, className }: Props) {
	return <p className={className}>{children}</p>;
}
